import { ReceivingMethodStoreTypeTitle, StoreType, ZoneTypes } from './enums';
import { IconMissions24 } from '@lentau/ui-kit/core/types/icon.interfaces';
import { Zone } from 'angular-api-gateway/v1/model/zone';
import { environmentBrand } from '@lentau/ui-kit/core/environments/environment.brand';

export const AddressMissionIconMap = {
  common: IconMissions24.Hyper,
  fast: IconMissions24.Syper,
  zoo: IconMissions24.Zoo,
  eco: IconMissions24.Ekonom,
  garage: IconMissions24.Vingarazh,
  allday: IconMissions24.AllDay,
  pickup: IconMissions24.TakeAway,
  b2b: IconMissions24.Express,
  b2big: IconMissions24.Delivery,
};

export type AddressMissionIconKey = keyof typeof AddressMissionIconMap;

export const getAddressMissionIcon: (type: string | null | undefined) => string = (
  type: string | null | undefined
): string => {
  if (type && type in AddressMissionIconMap) {
    return AddressMissionIconMap[type as AddressMissionIconKey];
  }

  return AddressMissionIconMap.common;
};

export const DEFAULT_MISSION_ADDRESS: Zone = {
  description: 'Более 35 000 товаров на любой вкус',
  icon: 'https://cdn.lentochka.lenta.com/resample/0x0/photo/icons/_track.png',
  isActive: true,
  isSelected: true,
  name: 'Гипер Лента',
  time: '01:30',
  timeDisplay: '~ 1 ч. 30 мин.',
  type: 'common',
  zoneId: null,
  infoModalText: null,
  infoModalTitle: null,
  store: null,
  position: null,
  realTime: null,
  minOrderAmount: null,
};

export const DEFAULT_MISSION_ADDRESS_B2B: Zone = {
  description: 'Более 35 000 товаров на любой вкус',
  icon: 'https://cdn.lentochka.lenta.com/resample/0x0/photo/icons/_track.png',
  isActive: true,
  isSelected: true,
  name: 'Экспресс',
  time: '01:30',
  timeDisplay: '~ 1 ч. 30 мин.',
  type: 'common',
  zoneId: null,
  infoModalText: null,
  infoModalTitle: null,
  store: null,
  position: null,
  realTime: null,
  minOrderAmount: null,
};

export const storeTypeClass: Record<string, string> = {
  [StoreType.Hm]: 'store-type_hyper',
  [StoreType.Sm]: 'store-type_super',
  [StoreType.Zo]: 'store-type_zoo',
  [StoreType.Ec]: 'store-type_econom',
  [StoreType.Al]: 'store-type_alco',
  [StoreType.Dy]: 'store-type_dom',
  [StoreType.Mm]: 'store-type_monetka',
};

/** Класс бейджа формата ТК при exp_zones_shops_information=test (цвет — через style). */
export const storeTypeGbClass: string = 'store-type_gb';

export const storeTypeTitle: Record<string, string> = {
  [StoreType.Hm]: 'Гипер',
  [StoreType.Sm]: 'Супер',
  [StoreType.Zo]: 'Зоо',
  [StoreType.Ec]: 'Эконом',
  [StoreType.Al]: 'Вингараж',
  [StoreType.Dy]: 'Дом',
  [StoreType.Mm]: 'Монетка',
};

export const storeTypeExtraSmallImage: Record<string, string> = {
  [StoreType.Al]: environmentBrand.RETAIL_BRAND + 'start-page/vingarazh-32.png',
  [StoreType.Zo]: environmentBrand.RETAIL_BRAND + 'start-page/zoo-32.png',
  [StoreType.Ec]: environmentBrand.RETAIL_BRAND + 'start-page/ekonom-32.png',
  [StoreType.Sm]: environmentBrand.RETAIL_BRAND + 'start-page/syper-32.png',
  [StoreType.Hm]: environmentBrand.RETAIL_BRAND + 'start-page/hyper-32.png',
};

export const storeTypeSmallImage: Record<string, string> = {
  [StoreType.Al]: environmentBrand.RETAIL_BRAND + 'start-page/vingarazh-48.png',
  [StoreType.Zo]: environmentBrand.RETAIL_BRAND + 'start-page/zoo-48.png',
  [StoreType.Ec]: environmentBrand.RETAIL_BRAND + 'start-page/ekonom-48.png',
  [StoreType.Sm]: environmentBrand.RETAIL_BRAND + 'start-page/super-48.png',
  [StoreType.Hm]: environmentBrand.RETAIL_BRAND + 'start-page/hyper-48.png',
};

export const storeIcon: Record<string, string> = {
  [StoreType.Al]: 'vingarazh-32',
  [StoreType.Zo]: 'zoo-32',
  [StoreType.Ec]: 'ekonom-32',
  [StoreType.Sm]: 'syper-32',
  [StoreType.Hm]: 'hyper-32',
};

export const storeSortPosition: Record<string, number> = {
  [StoreType.Hm]: 1,
  [StoreType.Sm]: 2,
  [StoreType.Zo]: 3,
  [StoreType.Ec]: 4,
  [StoreType.Al]: 5,
  [StoreType.Dy]: 6,
  [StoreType.Mm]: 7,
};

export const storeName: Record<string, string> = {
  [StoreType.Al]: 'Вингараж',
  [StoreType.Zo]: 'Зоо Маркет',
  [StoreType.Ec]: 'Эконом',
  [StoreType.Sm]: 'Супер Лента',
  [StoreType.Hm]: 'Гипер Лента',
};

export const storeTypeMediumImage: Record<string, string> = {
  [StoreType.Al]: environmentBrand.RETAIL_BRAND + 'start-page/vingarazh-70.png',
  [StoreType.Zo]: environmentBrand.RETAIL_BRAND + 'start-page/paw-70.png',
  [StoreType.Ec]: environmentBrand.RETAIL_BRAND + 'start-page/express-70.png',
  [StoreType.Sm]: environmentBrand.RETAIL_BRAND + 'start-page/pinkflower-70.png',
  [StoreType.Hm]: environmentBrand.RETAIL_BRAND + 'start-page/sunflower-70.png',
};

export const allDay: string = 'круглосуточно';

export const RECEIVING_METHOD_ZONE_TO_STORE_TYPE: Record<string, StoreType> = {
  [ZoneTypes.HM]: StoreType.Hm,
  [ZoneTypes.SM]: StoreType.Sm,
  [ZoneTypes.ZO]: StoreType.Zo,
  [ZoneTypes.EC]: StoreType.Ec,
  [ZoneTypes.FA]: StoreType.Sm,
};

export const RECEIVING_METHOD_ZONE_TYPE_TITLE: Record<string, string> = {
  [ZoneTypes.HM]: ReceivingMethodStoreTypeTitle.Hm,
  [ZoneTypes.SM]: ReceivingMethodStoreTypeTitle.Sm,
  [ZoneTypes.ZO]: ReceivingMethodStoreTypeTitle.Zo,
  [ZoneTypes.EC]: ReceivingMethodStoreTypeTitle.Ec,
  [ZoneTypes.FA]: ReceivingMethodStoreTypeTitle.Sm,
};

export const RECEIVING_METHOD_STORE_TYPE_TITLE: Record<string, ReceivingMethodStoreTypeTitle> = {
  [StoreType.Hm]: ReceivingMethodStoreTypeTitle.Hm,
  [StoreType.Sm]: ReceivingMethodStoreTypeTitle.Sm,
  [StoreType.Zo]: ReceivingMethodStoreTypeTitle.Zo,
  [StoreType.Ec]: ReceivingMethodStoreTypeTitle.Ec,
  [StoreType.Al]: ReceivingMethodStoreTypeTitle.Al,
  [StoreType.Dy]: ReceivingMethodStoreTypeTitle.Dy,
};
